export const findTabs = (): NodeListOf<Element> => {
    return document.querySelectorAll('.our-structure__tab')
}

export const findDropDowns = (): NodeListOf<Element> => {
    return document.querySelectorAll('.our-structure__dropdown')
}

export const findTexts = (): NodeListOf<Element> => {
    return document.querySelectorAll('.our-structure__introduction-text')
}

export const findTabSlider = (): HTMLElement | null => {
    const slider = document.querySelector('.our-structure__tabs-slider')

    if (slider && slider instanceof HTMLElement) {
        return slider
    }

    return null
}

export const findIntermezzo = (): HTMLElement | null => {
    const intermezzo = document.querySelector('.osi')

    if (intermezzo && intermezzo instanceof HTMLElement) {
        return intermezzo
    }

    return null
}

export const findIntermezzoCanvas = (container: HTMLElement): HTMLElement | null => {
    const canvas = container.querySelector('.osi__canvas')

    if (canvas && canvas instanceof HTMLElement) {
        return canvas
    }

    return null
}

export const findDropdownContainer = (): HTMLElement | null => {
    const container = document.querySelector('.our-structure__tabs-dropdown--container')

    if (container && container instanceof HTMLElement) {
        return container
    }

    return null
}

export const findActiveDropdown = (): HTMLElement | null => {
    const dropdown = document.querySelector('.our-structure__tabs-dropdown--active')

    if (dropdown && dropdown instanceof HTMLElement) {
        return dropdown
    }

    return null
}

export const findActiveTextContainer = (parent: Element): HTMLElement | null => {
    const activeTextContainer = parent.querySelector('.our-structure__tabs-dropdown--active-text')

    if (activeTextContainer && activeTextContainer instanceof HTMLElement) {
        return activeTextContainer
    }

    return null
}

export const findGrid = (): HTMLElement | null => {
    const grid = document.querySelector('.our-structure__grid')

    if (grid && grid instanceof HTMLElement) {
        return grid
    }

    return null
}

export const findGridContainer = (): HTMLElement | null => {
    const container = document.querySelector('.our-structure__grid__container')

    if (container && container instanceof HTMLElement) {
        return container
    }

    return null
}

export const findCardTemplate = (): HTMLElement | null => {
    const template = document.querySelector('.our-structure__card-template')

    if (template && template instanceof HTMLElement) {
        return template
    }

    return null
}
